const SettingsTab = () => {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          paddingTop: 20,
        }}
      >
        <h1>Settings</h1>
      </div>
    );
  };
  
  export default SettingsTab;
  